



































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';

import { endpoints } from '../../endpoints';
import buildUrl from 'build-url';

import { DatasetState } from '@/store/datasets/types';

import SCEMap from './Map.vue';
import Metrics from './Metrics.vue';
import MetricsHistogram from './MetricsHistogram.vue';
import CommoditySunburst from './CommoditySunburst.vue';

import { eventLoading } from '@/components/sce/EventLoading';// This class controls loading state to update progress bar

@Component({
    components: {
        SCEMap,
        Metrics,
        MetricsHistogram,
        CommoditySunburst
    }
})
export default class SupplyChainExplorer extends Vue {

    @State('datasets') datasets!: DatasetState;
    @Action('datasets/getDatasets') getDatasets: any;

    show_splash: boolean = true;

    // Display Settings.
    commodity: string = "apples";
    metric: string = "tonnes";
    spatial_type: string = "lga";
    border_crossings: number | null = null;
    spatial_selection: any = null;
    supply_chain_leg: string = "production_imports";
    loading: boolean = false; // Controls progress bar

    histogramVisible = false;
    selectedMetric = '';
    metricKey = '';

    spatialBorderCrossing: boolean = false; // Used to track when a border crossings chart horizontal bar was clicked (i.e. supply chain leg category filter should be applied)

    get dataset(): any {
        return this.datasets.dataset;
    }


    //-----------------------------
    //--- Visualization Options ---
    //-----------------------------

    get commodityList() {
        var list = Object.keys(this.commodity_items);

        var ret = list.map(value => {
            // Replace underscores with spaces
            var spaced = value.replace(/_/g, ' ');

            // Capitalize each word
            var text = spaced
                .split(' ')
                .map(value => value.charAt(0).toUpperCase() + value.slice(1))
                .join(' ');
            return { text: text, value: value };
        });

        // Sort alphabetically by text
        return ret.sort((a, b) => a.text.localeCompare(b.text));
    }

    get includedCommodities() {
        var commodities = this.commodity_items[this.commodity.toLowerCase()]?.map((c: any) => c.replace(/_/g, " ")) || [];
        return commodities.join(", ")
    }


    // The available metric items that can be reported upon.
    // Note: these are temporary for the moment.
    // They need to be:
    // 1) % Total Tonnes (from for first 3 maps, to for last map)
    // 2) Number of unique enterprises (destinations for first 3 maps, origins for last map)
    // 3) Number of unique LGAs (destinations for first 3 maps, origins for last map)
    metric_items = {
        //'trip_transport_costs': {
        //    text: 'Percent of total freight task costs',
        //    value: 'trip_transport_costs',
        //    valueformat: "$,.3s",
        //    valuesuffix: "",
        //    units: '($)',
        //    tickprefixformat: "$",
        //    customDisabled: false
        //},
        'tonnes': {
            text: 'Percent of total tonnes',
            value: 'tonnes',
            valueformat: ",.4s",
            valuesuffix: " t",
            units: '(tonne)',
            tickprefixformat: "",
            customDisabled: false
        },
        'node': {
            text: 'Enterprise Counts',
            value: 'node',
            valueformat: ",.4s",
            valuesuffix: "",
            units: '(ent)',
            tickprefixformat: "",
            customDisabled: false
        },
        'lga': {
            text: 'Local Government Area Counts',
            value: 'lga',
            valueformat: ",.4s",
            valuesuffix: "",
            units: '(lga)',
            tickprefixformat: "",
            customDisabled: false
        },
        'state': {
            text: 'State and Territory Counts',
            value: 'state',
            valueformat: ",.4s",
            valuesuffix: "",
            units: '(st/terr)',
            tickprefixformat: "",
            customDisabled: false
        },
    }


    // The spatial regions which can be visualized on the map.
    spatialTypeItems = {
        'lga': {
            text: 'Local Government Areas',
            value: 'lga',
            geojson: './docs/lga.json'
        },
        'state': {
            text: 'States and Territories',
            value: 'state',
            geojson: './docs/states.json'
        },
    }


    // Options loaded via endpoints.
    commodity_items: any = {}
    lga_items: string[] = [];
    state_items: string[] = [];


    // The available selection items for selecting the number of border crossings.
    border_crossings_items = [
        { value: 0, text: "0 Crossings (i.e. Intrastate)" },
        { value: 1, text: "1 Crossing (i.e. Neighbouring)" },
        { value: 2, text: "2 Crossings" },
        { value: 3, text: "3 Crossings" },
    ]

    // This is only temporary...
    get commodityGroupsUrl() {
        return process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/commoditygroups";
    }

    mounted() {
        // Load the list of commodities.
        Vue.axios({
            url: this.commodityGroupsUrl
        }).then((response: any) => {
            this.commodity_items = response.data;
        }, (error: any) => {
            console.log(error);
        });

        // Load the boundary datasets.
        if (this.dataset) {
            this.onDatasetChanged();
        }
    }

    @Watch('dataset', { deep: true })
    onDatasetChanged() {

        // Load the list of LGAs.
        Vue.axios({
            url: buildUrl(endpoints.boundariesUrl(this.dataset), { queryParams: { layer: 'LGA' } })
        }).then((response: any) => {
            this.lga_items = response.data;
        }, (error: any) => {
            console.log(error);
        });

        // Load the list of States & Territories.
        Vue.axios({
            url: buildUrl(endpoints.boundariesUrl(this.dataset), { queryParams: { layer: 'STE11a' } })
        }).then((response: any) => {
            this.state_items = response.data;
        }, (error: any) => {
            console.log(error);
        });
    }

    // Disables supply chain leg filter
    @Watch('border_crossings')
    @Watch('spatial_selection')
    onSelectionChanged() {
        if (this.border_crossings === null && this.spatial_selection === null) {
            this.clearSpatialSelection_all();
        }
    }

    created() {
        this.getDatasets()
        eventLoading.$on('loading', this.setLoading);
    }

    beforeDestroy() {
        eventLoading.$off('loading', this.setLoading);
    }

    setLoading(isLoading: boolean) {
        this.loading = isLoading;
    }

    clearSpatialSelection_all() {
        this.spatial_selection = null;
        if (this.spatialBorderCrossing) { 
            this.border_crossings = null;
            this.spatialBorderCrossing = false
        }
    }

    clearSpatialSelection() {
        this.spatial_selection = null;
    }

    updateSpatialParams(e: any) {
        this.spatial_selection = e.points[0].location;
        this.supply_chain_leg = e.points[0].customdata[1] // map_id
    }

    //-----------------------------
    //-------      Data       -----
    //-----------------------------


    // Configuration for the 4 supply chain leg maps.
    densitymaps = {
        production_imports: {
            map_id: "production_imports",
            title: "Production and Imports",
            hint: "Production and Imports supply chain leg includes movements originating from enterprises where commodities are produced or imported. E.g. properties where fruit is grown or ports where commodities are imported.",
            direction: "from", //orig
        },
        processing: {
            map_id: "processing",
            title: "Processing",
            hint: "Processing supply chain leg includes movements originating from enterprises where commodities are processed. This involves transformations from incoming commodities to outgoing commodities. E.g. apples to fruit juice.",
            direction: "from" //orig
        },
        distribution: {
            map_id: "distribution",
            title: "Distribution",
            hint: "Distribution supply chain leg includes movements originating from enterprises where distribution of freight occurs. E.g. intermodals and distribution centers.",
            direction: "from" //orig
        },
        consumption_exports: {
            map_id: "consumption_exports",
            title: "Consumption and Exports",
            hint: "Consumption and Exports supply chain leg includes movements going to end-user enterprises or ports. E.g. commodities moving to supermarkets or ports for export.",
            direction: "to" //dest
        }
    }

    onMetricClicked(metricKey: string, title: string) {
        this.metricKey = metricKey;
        this.selectedMetric = title;
        this.histogramVisible = true;
    }

    onSunburstClicked(e: any) {
        this.commodity = e
    }

    onCrossingSelected(payload: { clickedValue: number; map_id: string }) {
        this.border_crossings = payload.clickedValue;
        this.supply_chain_leg = payload.map_id;
        this.spatialBorderCrossing = true;
    }

}

